module.exports = __webpack_public_path__ + "static/media/inc_img.e5857f8f.svg";